import { Component, Input } from '@angular/core';

@Component({
  selector: 's-polaris-text',
  templateUrl: './s-polaris-text.component.html',
  styleUrls: ['./s-polaris-text.component.scss'],
  standalone: false,
})
export class PolarisTextComponent {
  @Input() color: 'base' | 'subdued' = 'base';
  @Input() tone: 'custom' | 'success' | 'info' | 'neutral' | 'warning' | 'critical' = 'custom';
}
